module.exports = __webpack_public_path__ + "img/daniel-farias.30cea564.png";